import { displayToast, sendAppsignalError } from "../modules/utils";

export default class QvInformational {
  constructor(node) {
    this.element = node;
    this.filterbuttons = this.element.querySelectorAll(".js-qv-button");
    this.tabsWrapper = this.element.querySelector(".js-qv-tabs-wrapper");
    this.progressWrapper = this.element.querySelector(".js-qv-progress-wrapper");
    this.tabsContentWrapper = this.element.querySelector(".js-qv-tabs-content-wrapper");
    this.infoWrapper = this.element.querySelector(".js-qv-progress-info-wrapper");

    this.initialize();
  }

  initialize() {
    this.filterbuttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.filterbuttons.forEach((button) => {
          button.classList.remove("active");
        });

        event.currentTarget.classList.add("active");

        this.fetchContent(event.currentTarget.dataset.qvUrl);
      });
    });
  }

  fetchContent(url) {
    this.element.classList.add("is-loading");

    fetch(url)
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong on api server!");
      })
      .then((html) => {
        const { tabs, progress } = html;

        if (this.tabsContentWrapper !== null) {
          const { tabContent } = html;
          this.tabsContentWrapper.innerHTML = tabContent;
        }

        this.tabsWrapper.innerHTML = tabs;
        this.progressWrapper.innerHTML = progress;

        if (html.infoContent) {
          this.infoWrapper.innerHTML = html.infoContent;
        }
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "QvInformational", {
          response: this.response,
        });
      })
      .finally(() => {
        this.element.classList.remove("is-loading");
      });
  }
}
